// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"aa0a76b9","156":"511fb8bc","385":"61ace893","588":"5567fea4"}[chunkId] + ".chunk.css";
};